import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpClientService } from "./http-client.service";
import {
  ExternalQuoteManagerFilterParams,
  ExternalQuoteManagerFilterDealershipsResponse,
  ExternalQuoteManagerFilterEpsResponse,
  ExternalQuoteManagerFilterFinanceManagersResponse,
  ExternalQuoteManagerFilterSalesmenResponse,
  ExternalQuoteManagerIndexParams,
  ExternalQuoteManagerIndexResponse,
} from "../interfaces/external-quote-manager.interface";

@Injectable()
export class ExternalQuotesService {
  constructor(private readonly http: HttpClientService) {}

  /**
   * Manager / EP external quotes list (internal users).
   * GET /api/external_quotes/manager_index
   */
  getManagerIndex(params: ExternalQuoteManagerIndexParams): Observable<ExternalQuoteManagerIndexResponse> {
    const httpParams = this.buildManagerScopeHttpParams(params);
    return this.http.get<ExternalQuoteManagerIndexResponse>("/api/external_quotes/manager_index", {
      params: httpParams,
    });
  }

  /** GET /api/external_quotes/manager_filter_eps */
  getManagerFilterEps(params: ExternalQuoteManagerFilterParams): Observable<ExternalQuoteManagerFilterEpsResponse> {
    return this.http.get<ExternalQuoteManagerFilterEpsResponse>("/api/external_quotes/manager_filter_eps", {
      params: this.buildManagerScopeHttpParams(params),
    });
  }

  /** GET /api/external_quotes/manager_filter_dealerships */
  getManagerFilterDealerships(
    params: ExternalQuoteManagerFilterParams
  ): Observable<ExternalQuoteManagerFilterDealershipsResponse> {
    return this.http.get<ExternalQuoteManagerFilterDealershipsResponse>(
      "/api/external_quotes/manager_filter_dealerships",
      { params: this.buildManagerScopeHttpParams(params) }
    );
  }

  /** GET /api/external_quotes/manager_filter_salesmen */
  getManagerFilterSalesmen(
    params: ExternalQuoteManagerFilterParams
  ): Observable<ExternalQuoteManagerFilterSalesmenResponse> {
    return this.http.get<ExternalQuoteManagerFilterSalesmenResponse>("/api/external_quotes/manager_filter_salesmen", {
      params: this.buildManagerScopeHttpParams(params),
    });
  }

  /** GET /api/external_quotes/manager_filter_finance_managers */
  getManagerFilterFinanceManagers(
    params: ExternalQuoteManagerFilterParams
  ): Observable<ExternalQuoteManagerFilterFinanceManagersResponse> {
    return this.http.get<ExternalQuoteManagerFilterFinanceManagersResponse>(
      "/api/external_quotes/manager_filter_finance_managers",
      { params: this.buildManagerScopeHttpParams(params) }
    );
  }

  private buildManagerScopeHttpParams(params: Partial<ExternalQuoteManagerIndexParams>): HttpParams {
    let httpParams = new HttpParams();
    const entries: [keyof ExternalQuoteManagerIndexParams, string | number | undefined][] = [
      ["page", params.page],
      ["per_page", params.per_page],
      ["search_query", params.search_query],
      ["status", params.status],
      ["dealership_id", params.dealership_id],
      ["internal_user_id", params.internal_user_id],
      ["salesman_full_name", params.salesman_full_name],
      ["finance_manager_full_name", params.finance_manager_full_name],
      ["view_as", params.view_as],
      ["created_after", params.created_after],
      ["created_before", params.created_before],
    ];
    for (const [key, value] of entries) {
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        httpParams = httpParams.set(key, String(value));
      }
    }
    return httpParams;
  }
}
